import {EVENTS, TYPES, URLS} from "../constants";
import BaseForm from "./baseform";

export default class Verifyform extends BaseForm {
	defaultOptions() {
		return {
			type: "",
			phoneSelector: "",
			container: "",
			ajaxUrl: URLS.VERIFY,
			updateOnChange: false,
			updateOnVerified: false,
			disableFormBeforeVerify: true,// дизаблить форму регистрации до успешной верификации (кнопку input[type=submit] формы)
			formId: "", // id формы регистрации, если есть,
		};
	}

	setOptions(options) {
		this.options = Object.assign(this.defaultOptions(), options);

		this.initPhoneSelector();

		this.initContainer();

		this.initRegisterSubmit();
	}

	initPhoneSelector() {
		if (!this.options.phoneSelector) {
			this.obPhone = false;

			return;
		}

		this.obPhone = $(this.options.phoneSelector);
	}

	initContainer() {
		if (this.obPhone && this.obPhone.length > 0) {
			this.obPhone.after($("<div id='efpbInternalPhoneContainer'></div>"));
			this.options.container = "#efpbInternalPhoneContainer";
			this.obHtml = $(this.options.container);
		} else if (this.options.container) {
			this.obHtml = $(this.options.container);
		} else {
			$("body").append($("<div id='efpbInternalContainer' style='display:none;'></div>"));
			this.options.container = "#efpbInternalContainer";
			this.obHtml = $(this.options.container);
		}
	}

	/**
	 * Ищем форму регистрации и ее кнопку submit
	 */
	initRegisterSubmit() {
		let thatPtr = this;

		this.obForm = false;
		this.obSubmit = false;

		if (this.options.type !== "REGISTER") {
			return;
		}

		if (this.options.formId) {
			this.obForm = $(this.options.formId);
		} else if (this.obHtml && this.obHtml.length > 0) {
			if (this.obHtml.parents("form").length > 0) {
				this.obForm = $(this.obHtml.parents("form")[0]);
			} else {

				$("body").find("form").each(function () {
					if ($(this).find("[name=AUTH_FORM]").length > 0
						&& $(this).find("[name=TYPE][value=REGISTRATION]").length > 0
					) {
						thatPtr.obForm = $(this);
					}
				});
			}
		}

		if (this.obForm.length > 0) {
			this.obSubmit = this.obForm.find("input[type=submit]");
		}
	}

	getLoadComponentParams() {
		return {
			type: this.options.type,
			phone: this.obPhone ? this.obPhone.val() : "",
		};
	}

	init(options) {
		super.init(options);

		if (this.obPhone && this.obPhone.length > 0) {
			this.updatePhone();

			if (this.options.updateOnChange) {
				this.obPhone.on("change", () => {
					this.updatePhone();
				});
			}
		} else {
			this.logInfo("Не найдено поле " + this.options.phoneSelector + " для инициализации формы подтверждения телефона");
		}

		if (this.options.disableFormBeforeVerify && this.obSubmit && this.obSubmit.length > 0) {
			this.obSubmit.attr("disabled", "disabled");
		}
	}

	updatePhone() {
		let curPhone = this.obPhone.val();
		BX.onCustomEvent(EVENTS.VERIFY.SET_PHONE, [{
			phone: curPhone,
			disabled: !!curPhone
		}]);
	}

	setVerifiedPhone(phone) {
		/**
		 * Установить телефон в инпут формы
		 */
		if (this.options.updateOnVerified && this.obPhone && this.obPhone.length > 0) {
			this.obPhone.val(phone);
			this.obPhone.attr("readonly", "readonly");
		}

		BX.onCustomEvent(EVENTS.VERIFY.SET_OPTIONS, [{
			showVerifiedPhone: this.options.type === TYPES.REGISTER && (!this.obPhone || this.obPhone.length == 0)
		}]);

		this.setSubmitAvailable();
	}

	setSubmitAvailable() {
		/**
		 * Включить обратно доступность отправки формы регистрации
		 */
		if (this.options.disableFormBeforeVerify && this.obSubmit && this.obSubmit.length > 0) {
			this.obSubmit.removeAttr("disabled");
		}
	}
}